import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { RemoteDiagnosticsVddGenericStructure, SetNewValueObject } from '@vi-iot/client';

@Component({
  selector: 'app-vdd-boolean-choice',
  templateUrl: './vdd-boolean-choice.component.html',
  styleUrls: ['./vdd-boolean-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddBooleanChoiceComponent {
  @Input() matchedValue: RemoteDiagnosticsVddGenericStructure;
  @Input() isVddEditable: boolean;
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  constructor() {}

  onToggleChange(value: MatSlideToggleChange): void {
    const newValue = value.checked
      ? this.matchedValue.structure[1].texttableentry
      : this.matchedValue.structure[0].texttableentry;

    this.matchedValue.value = newValue;

    this.setNewValue.emit({
      path: this.matchedValue?.path,
      newValue,
    });
  }
}
